import {
  Component,
  Input,
  Output,
  EventEmitter,
  HostListener,
} from "@angular/core";

@Component({
  selector: "app-button-select",
  templateUrl: "./button-select.component.html",
  styleUrls: ["./button-select.component.css"],
})
export class ButtonSelectComponent {
  @Input() options: { value: string; label: string }[] = [];
  @Input() selected: string;
  @Input() label: string;
  @Input() disabled: boolean = false;
  @Input() type: string = "button";

  @Input() optionsIcons: {
    icon: string;
    iconColor: string;
    value: string;
    label: string;
  }[] = [];

  @Input() value: string;
  @Input() outline: boolean = false;
  @Input() icon: string = "";
  @Input() colorIcon: string = "#000";
  @Input() widthPx: number;
  @Input() specialWidth: number;

  isMobile: boolean = false;
  //
  @HostListener("window:resize", ["$event"])
  onResize(event) {
    this.isMobile = window.innerWidth <= 768;
  }
  ngOnInit() {
    this.isMobile = window.innerWidth <= 768;
  }
  //
  @Output() selectedChange = new EventEmitter<string>();

  onChange(newValue: string) {
    this.selected = newValue;
    this.selectedChange.emit(newValue);
  }

  getSelectedLabel(): string {
    const selectedOption = this.options.find(
      (option) => option.value === this.selected
    );
    return selectedOption ? selectedOption.label : "";
  }

  getSelectedLabelIcons(): string {
    const selectedOption = this.optionsIcons.find(
      (option) => option.value === this.selected
    );
    return selectedOption ? selectedOption.label : "";
  }

  getSelectedValueIcon(): string {
    const selectedOption = this.optionsIcons.find(
      (option) => option.value === this.selected
    );
    return selectedOption ? selectedOption.value : "";
  }

  getSelectedLabelIconColor(): string {
    const selectedOptionColor = this.optionsIcons.find(
      (option) => option.value === this.selected
    );
    return selectedOptionColor ? selectedOptionColor.iconColor : "";
  }
}
